var _style, _path, _polyline, _circle, _polyline2, _circle2, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#f4b536;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:6,6;}\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:4,4;}\n\t.st4{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;}\n\t.st5{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-dasharray:3.1081,3.1081;}\n\t\n\t\t.st6{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:4,3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27,17V8.8c1.2-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2H8.8C8.4,3.8,7.3,3,6,3C4.3,3,3,4.3,3,6  c0,1.3,0.8,2.4,2,2.8v14.4c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3c1.3,0,2.4-0.8,2.8-2H17"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "15,23 9,23 9,9 23,9 23,15 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 13,
    cy: 13,
    r: 1
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "9,20 16,16 17,17 "
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22,
    cy: 22,
    r: 7
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 22,
    x2: 22,
    y1: 19,
    y2: 25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 19,
    x2: 25,
    y1: 22,
    y2: 22
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/add_image.947f5fc8d560413cd8916ac2406a2077.svg";
export { ForwardRef as ReactComponent };